
      <div class="record-texts ng-star-inserted">
        <span class="form-control-plaintext field-list border-bottom form-control-sm pl-2 record-texts long-text ng-star-inserted">
          {{ reportFields.length === 0 ? '--' : translatedFields }}
        </span>
      </div>
  